import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveDirective as _resolveDirective, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0ec68ab4")

_pushScopeId("data-v-0ec68ab4")
const _hoisted_1 = {
  key: 0,
  class: "spark-docs-ad-popup-form__message"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "message__title" }, "Ваша заявка принята", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "message__description margin" }, "Спасибо! Ваша заявка успешно отправлена.", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "message__description" }, "Наши специалисты свяжутся с вами в ближайшее время.", -1)
const _hoisted_5 = {
  key: 1,
  class: "spark-docs-ad-popup-form__container"
}
const _hoisted_6 = { class: "container__header" }
const _hoisted_7 = { class: "header__close" }
const _hoisted_8 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4.29289 4.79289C4.68342 4.40237 5.31658 4.40237 5.70711 4.79289L10 9.08579L14.2929 4.79289C14.6834 4.40237 15.3166 4.40237 15.7071 4.79289C16.0976 5.18342 16.0976 5.81658 15.7071 6.20711L11.4142 10.5L15.7071 14.7929C16.0976 15.1834 16.0976 15.8166 15.7071 16.2071C15.3166 16.5976 14.6834 16.5976 14.2929 16.2071L10 11.9142L5.70711 16.2071C5.31658 16.5976 4.68342 16.5976 4.29289 16.2071C3.90237 15.8166 3.90237 15.1834 4.29289 14.7929L8.58579 10.5L4.29289 6.20711C3.90237 5.81658 3.90237 5.18342 4.29289 4.79289Z",
  fill: "#64748B"
}, null, -1)
const _hoisted_9 = { class: "spark-docs-ad-popup-form__input" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "input__label" }, [
  /*#__PURE__*/_createTextVNode("Ваше имя "),
  /*#__PURE__*/_createVNode("span", null, "*")
], -1)
const _hoisted_11 = { class: "spark-docs-ad-popup-form__input" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "input__label" }, [
  /*#__PURE__*/_createTextVNode("Ваш номер телефона "),
  /*#__PURE__*/_createVNode("span", null, "*")
], -1)
const _hoisted_13 = { class: "spark-docs-ad-popup-form__input" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "input__label" }, "Название компании", -1)
const _hoisted_15 = { class: "container__footer" }
const _hoisted_16 = { class: "footer__policy" }
const _hoisted_17 = /*#__PURE__*/_createVNode("svg", {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M10.1193 2.92648C10.3015 3.10872 10.3015 3.4042 10.1193 3.58644L4.98594 8.71978C4.8037 8.90202 4.50822 8.90202 4.32597 8.71978L1.99264 6.38644C1.8104 6.2042 1.8104 5.90872 1.99264 5.72648C2.17489 5.54423 2.47036 5.54423 2.65261 5.72648L4.65596 7.72983L9.45931 2.92648C9.64155 2.74423 9.93703 2.74423 10.1193 2.92648Z",
    fill: "currentColor"
  })
], -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "policy__message" }, [
  /*#__PURE__*/_createTextVNode(" Подтверждаю ознакомление с "),
  /*#__PURE__*/_createVNode("a", null, "политикой конфиденциальности")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createBlock("form", {
    class: "spark-docs-ad-popup-form",
    onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
  }, [
    (_ctx.completed)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _hoisted_2,
          _hoisted_3,
          _hoisted_4,
          _createVNode("button", {
            class: "spark-docs-ad-popup-form__button",
            type: "button",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args)))
          }, " Вернуться в кабинет ")
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              (_openBlock(), _createBlock("svg", {
                width: "20",
                height: "21",
                viewBox: "0 0 20 21",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args)))
              }, [
                _hoisted_8
              ]))
            ]),
            _createVNode("div", _hoisted_9, [
              _hoisted_10,
              _withDirectives(_createVNode("input", {
                class: ["input__control", { 'control--invalid': _ctx.v$.name.$error }],
                placeholder: "Введите ваше имя",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.name = $event)),
                disabled: _ctx.disabled
              }, null, 10, ["disabled"]), [
                [_vModelText, _ctx.state.name]
              ])
            ]),
            _createVNode("div", _hoisted_11, [
              _hoisted_12,
              _withDirectives(_createVNode("input", {
                class: ["input__control", { 'control--invalid': _ctx.v$.phone.$error }],
                placeholder: "+7 (123) 456 78 90",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.phone = $event)),
                disabled: _ctx.disabled
              }, null, 10, ["disabled"]), [
                [_directive_maska, { mask: '+7 (###) ### ## ##' }],
                [_vModelText, _ctx.state.phone]
              ])
            ]),
            _createVNode("div", _hoisted_13, [
              _hoisted_14,
              _withDirectives(_createVNode("input", {
                class: "input__control",
                placeholder: "Введите название компании",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.company = $event)),
                disabled: _ctx.disabled
              }, null, 8, ["disabled"]), [
                [_vModelText, _ctx.state.company]
              ])
            ])
          ]),
          _createVNode("div", _hoisted_15, [
            _createVNode("button", {
              class: "spark-docs-ad-popup-form__button",
              disabled: _ctx.disabled,
              type: "submit"
            }, " Отправить заявку ", 8, ["disabled"]),
            _createVNode("div", _hoisted_16, [
              _createVNode("div", {
                class: ["spark-docs-ad-popup-form__checkbox", {
                            'checkbox--disabled': _ctx.disabled,
                            'checkbox--checked': _ctx.state.is_agree,
                            'checkbox--invalid': _ctx.state.is_submitted && !_ctx.state.is_agree,
                        }],
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.toggleCheckbox && _ctx.toggleCheckbox(...args)))
              }, [
                _hoisted_17
              ], 2),
              _hoisted_18
            ])
          ])
        ]))
  ], 32))
})